import { Video as LucideIcon } from "lucide-react";
import { Shield, ArrowRight, Lock } from "lucide-react";
import {
  Eye,
  Server,
  CheckCircle,
  Users,
  Zap,
  Globe,
  CheckCircle2,
  Headphones,
  BarChart3,
} from "lucide-react";
import { useState } from "react";
import doc from "../../images/doc.png";
import data from "../../images/data_manage.webp";
import { GrDocumentConfig } from "react-icons/gr";
import { FaRegLightbulb } from "react-icons/fa";
import { VscDebugDisconnect } from "react-icons/vsc";
import { AiOutlineAudit } from "react-icons/ai";
import { TfiEmail } from "react-icons/tfi";
import { TbDatabaseEdit } from "react-icons/tb";
import { TbReportAnalytics } from "react-icons/tb";
import { CiMobile1 } from "react-icons/ci";
const DMS = () => {
  const features = [
    {
      icon: GrDocumentConfig,
      title: "Document Management",
      description:
        "MapleDoc offers a centralized repository to store and manage all your documents. Users can upload, download, and edit documents, and manage versions.",
    },
    {
      icon: GrDocumentConfig,
      title: "Workflow Management",
      description:
        "MapleDoc provides a workflow engine that enables users to define and automate business processes.",
    },
    {
      icon: FaRegLightbulb,
      title: "Knowledge Management",
      description:
        "MapleDoc allows users to share knowledge and collaborate on documents. Users can search for documents using metadata, tags, and full-text search.",
    },
    {
      icon: Shield,
      title: "Security Management",
      description:
        "MapleDoc provides robust security features to protect your documents from unauthorized access. It ffers user-level permissions, access controls, and encryption.",
    },
    {
      icon: VscDebugDisconnect,
      title: "Integrations",
      description:
        "MapleDoc integrates with a wide range of third-party applications, including Microsoft Office, Google Drive, and Dropbox.",
    },
    {
      icon: AiOutlineAudit,
      title: "Audit Trail",
      description:
        "MapleDoc logs all user activity, providing a detailed audit trail of all document-related events.",
    },
    {
      icon: TfiEmail,
      title: "Email Management",
      description:
        "MapleDoc offers email management features that enable users to store, manage, and share emails.",
    },
    {
      icon: TbDatabaseEdit,
      title: "Records Management",
      description:
        "MapleDoc provides records management features that enable users to create and manage records, and ensure compliance with regulations.",
    },
    {
      icon: TbReportAnalytics,
      title: "Reporting",
      description:
        "MapleDoc offers powerful reporting capabilities that enable users to generate reports on document usage, workflow performance, and user activity.",
    },

    {
      icon: CiMobile1,
      title: "Mobile Access",
      description:
        "MapleDoc provides mobile access, enabling users to access and manage documents from anywhere, using their mobile devices.",
    },
  ];
  const [loading,setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    phone: "",
    password: "",
    textarea: "",
    organization :"",
    agree: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState("");

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: formData.fullname,
      email: formData.email,
      subject: "Request for DMS Product Demo",
      phone: formData.phone,
      organization : formData.organization,
      message: formData.textarea,
    };

    try {
      const response = await fetch(`http://localhost:5000/support`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        alert("✅ " + data.message);
        setContactForm(false);
        setFormData({
          fullname: "",
          email: "",
          phone: "",
          password: "",
          textarea: "",
          organization :"",
          agree: false,
        });
      } else {
        alert("❌ " + (data.error || "Failed to submit support request."));
      }
    } catch (err) {
      console.error("Error:", err);
      alert("⚠️ Something went wrong. Please try again.");
    }
  };
  const handleTrial = async (e) => {
    e.preventDefault();
  setLoading(true);
    const payload = {
      name: formData.fullname,
      email: formData.email,
      subject: "Request for DMS Product Trial",
      phone: formData.phone,
      organization : formData.organization,
      message: formData.textarea,
    };
    try {
      const response = await fetch(`https://backend.maplecloudtechnologies.com:7443/support`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
  setLoading(false)
      if (response.ok) {
        alert("✅ " + data.message);
        setTrialForm(false);
        setFormData({
          fullname: "",
          email: "",
          phone: "",
          password: "",
          textarea: "",
          company: "",
          organization : "",
          agree: false,
        });
      } else {
          setLoading(false)
        alert("❌ " + (data.error || "Failed to submit support request."));
      }
    } catch (err) {
        setLoading(false)
      console.error("Error:", err);
      alert("⚠️ Something went wrong. Please try again.");
    }
  };

  const [contactForm, setContactForm] = useState(false);
  const [trialForm, setTrialForm] = useState(false);
  const [users, setUsers] = useState("");
  return (
    <>
      {trialForm && (
        <div className="flex fixed w-full  items-center justify-center min-h-screen bg-gray-900/80 backdrop-blur-sm z-20 p-4">
          <div className="w-full max-w-md bg-slate-950 text-white p-8 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-2xl font-medium mb-6">
              Contact Us for a free trial{" "}
            </h1>
            <p className="text-gray-400 text-sm mb-6">
              Fill out the form below and our team will get in touch with you
              for a free trial.
            </p>
            <form
              onSubmit={(e) => {
                handleTrial(e);
                setUsers("");
              }}
              className="space-y-5"
            >
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Your name"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Tel."
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={formData.textarea || ""}
                    onChange={handleChange}
                    placeholder="Message..."
                    required
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              {errors && <p className="text-red-600 text-sm">{errors}</p>}

              <div className="w-full flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setTrialForm(false);
                    setFormData({
                      fullname: "",
                      email: "",
                      phone: "",
                      password: "",
                      textarea: "",
                      company: "",
                      agree: false,
                    });
                  }}
                  className="w-full bg-slate-600 text-white py-2 rounded-lg font-semibold hover:bg-yellow-700 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="w-full bg-yellow-600 text-white py-2 rounded-lg font-semibold hover:bg-yellow-700 transition"
                >
                  Request Trial
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {contactForm && (
        <div className="flex fixed w-full  items-center justify-center min-h-screen bg-gray-900/80 backdrop-blur-sm z-20 p-4">
          <div className="w-full max-w-md bg-slate-950 text-white p-8 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-2xl font-medium mb-6">
              Contact Us for a Product Demo
            </h1>
            <p className="text-gray-400 text-sm mb-6">
              Fill out the form below and our team will get in touch with you
              for a personalized demo.
            </p>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Your  name"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Tel."
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={formData.textarea || ""}
                    onChange={handleChange}
                    placeholder="Message..."
                    required
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              {errors && <p className="text-red-600 text-sm">{errors}</p>}

              <div className="w-full flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setContactForm(false);
                    setFormData({
                      fullname: "",
                      email: "",
                      phone: "",
                      password: "",
                      textarea: "",
                      company: "",
                      agree: false,
                    });
                  }}
                  className="w-full bg-slate-600 text-white py-2 rounded-lg font-semibold hover:bg-yellow-700 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="w-full bg-yellow-600 text-white py-2 rounded-lg font-semibold hover:bg-yellow-700 transition"
                >
                  Request Demo
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <section className="relative overflow-hidden pt-20 pb-10 px-4 sm:px-6 lg:px-8">
        {/* Background */}
        <div className="absolute inset-0 bg-gradient-to-b from-yellow-600/10 to-transparent"></div>
        <div className="absolute top-20 left-5 sm:left-10 w-56 sm:w-72 h-56 sm:h-72 bg-yellow-600/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-5 sm:right-10 w-64 sm:w-96 h-64 sm:h-96 bg-yellow-600/20 rounded-full blur-3xl"></div>

        {/* Main container */}
        <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-12 px-4 sm:px-8 mt-5">
          {/* Text Section */}
          <div className="text-start w-full lg:w-1/2 mt-5">
            <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/20 rounded-full px-4 py-2 mb-6">
              <Lock className="w-4 h-4 text-yellow-400" />
              <span className="text-sm text-yellow-300 font-medium">
                MCT Document Management System
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              <span className="block bg-gradient-to-r from-yellow-400 to-yellow-700 bg-clip-text text-transparent mb-2">
                MapleDoc
              </span>
              Web-based Document Management System.
            </h1>

            <p className="text-sm sm:text-lg text-slate-300 mb-10 leading-relaxed">
              MapleDoc is a web-based Document Management System (DMS) that
              provides a platform to manage the complete lifecycle of documents,
              from creation to archiving, versioning and record keeping. It
              allows users to collaborate on documents, share knowledge and
              improve productivity.
            </p>
          </div>

          {/* Right Side Form */}
          <div className="w-full lg:w-1/2 max-w-md bg-slate-900/40 backdrop-blur-md text-white p-6 sm:p-6 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-xl sm:text-2xl font-medium mb-6 text-center lg:text-left">
              Contact for free trial
            </h1>

            <form
              onSubmit={(e) => {
                handleTrial(e);
                setUsers("");
              }}
              className="space-y-3"
            >
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Your name"
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
               <div>
                <input
                  id="organization"
                  name="organization"
                  type="text"
                  value={formData.organization}
                  onChange={handleChange}
                  placeholder="Organization name"
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Tel."
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={formData.textarea || ""}
                    onChange={handleChange}
                    
                    placeholder="Message..."
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              {/* Checkbox */}
              <div className="flex items-start gap-2 text-sm">
                <input
                  id="agree"
                  name="agree"
                  type="checkbox"
                  checked={formData.agree}
                  onChange={handleChange}
                  
                  className="mt-1"
                />
                <label htmlFor="agree" className="text-gray-400">
                  I agree to the{" "}
                  <a href="#" className="text-yellow-400 hover:underline">
                    Terms of Service
                  </a>{" "}
                  and{" "}
                  <a href="#" className="text-yellow-400 hover:underline">
                    Privacy Policy
                  </a>
                  .
                </label>
              </div>

              {/* Messages */}
              {errors && <p className="text-red-500 text-sm">{errors}</p>}
              {message && <p className="text-green-500 text-sm">{message}</p>}

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-yellow-600 text-white py-2 rounded-lg font-semibold hover:bg-yellow-700 transition"
              >
                {
                  loading ? 'Sending...' : ' Send Request'
                }
               
              </button>
            </form>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/20 rounded-full px-4 py-2 mb-6">
              <Globe className="w-4 h-4 text-yellow-400" />
              <span className="text-md text-yellow-300 font-medium">
                Features
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Features MapeDoc Provide
            </h2>
            <p className="text-xl text-slate-400 max-w-3xl mx-auto">
              From creation to archiving, versioning and record keeping
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((f) => (
              <div className="bg-slate-900 border border-slate-700 rounded-xl p-8 hover:border-blue-500/50 transition hover:shadow-3xl   hover:shadow-blue-500/10 group">
                <div className="bg-gradient-to-br from-yellow-500 to-yellow-800 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <f.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-medium text-white mb-3">
                  {f.title}
                </h3>
                <p className="text-slate-400 leading-relaxed text-xs">
                  {f.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section
        id="features"
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col items-center"
      >
        {/* Section Badge */}
        <div className="w-[280px] sm:w-[300px] flex justify-center text-lg items-center gap-2 bg-yellow-500/10 border border-yellow-500/20 rounded-full px-4 py-2 mb-10">
          <Globe className="w-6 h-6 text-yellow-400" />
          <span className="text-xl text-yellow-300 font-medium">
            Benefits Of MapleDoc
          </span>
        </div>

        {/* Content */}
        <div className="flex flex-col lg:flex-row w-full gap-10 lg:gap-16 items-start">
          {/* Left side - Illustration */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <img
              src={doc}
              alt="feature_img"
              className="w-full max-w-md lg:max-w-full h-auto object-contain"
            />
          </div>

          {/* Right side - Features */}
          <div className="w-full lg:w-1/2 mt-6 lg:mt-0 space-y-6">
            {[
              "Reduced time spent on processing files.",
              "Easy access to data improves communication within the organization and decision making.",
              "Manage the entire life cycle of your organizational documents from upload, retrieval to sharing.",
              "Convenient storage and retrieval of files.",
              "Loss of files are excluded.",
              "Manages the workflows of different department based on organization needs.",
              "Versioning of files in DMS can help Management to better track a document with no documents pile up.",
            ].map((feature, idx) => (
              <div key={idx} className="flex items-start gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-yellow-600/20 rounded-full flex items-center justify-center text-yellow-400">
                  <CheckCircle2 className="w-5 h-5" />
                </div>
                <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
                  {feature}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section className="bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white py-24 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
              Pricing Plans
            </span>
          </h2>
          <p className="text-slate-400 mb-16 max-w-2xl mx-auto text-lg">
            Transparent and flexible pricing tailored for individuals, startups,
            and enterprises. Upgrade as your business grows.
          </p>

          <div className="grid  md:grid-cols-3">
            <div className="bg-slate-800/60 backdrop-blur-lg rounded-3xl shadow-xl border border-slate-700 p-10  hover:shadow-yellow-500/20 transition duration-300">
              <h3 className="text-2xl font-semibold mb-3">Plan 1</h3>
              <div className="text-3xl font-bold mt-6 text-yellow-400">
                <span className="text-xl text-slate-200">Document</span> 05 GB
              </div>

              <div className="flex items-center gap-5 my-20">
                <button
                  onClick={() => {
                    // navigate('/')
                  }}
                  className="w-full bg-white text-yellow-700 font-semibold py-3 rounded-xl shadow-md hover:bg-slate-100 transition"
                >
                  Start Trial
                </button>
                <button
                  onClick={() => {
                    setTrialForm(true);
                    setUsers(" for 5 GB");
                  }}
                  className="w-full bg-yellow-600 hover:bg-yellow-500 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-yellow-500/40 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>

            <div className="relative z-10 scale-110 bg-gradient-to-b from-gray-600 to-yellow-900 rounded-3xl shadow-2xl p-10  transition duration-300 border border-slate-700">
              <h3 className="text-2xl font-semibold mb-3">Enterprise</h3>
              <div className="text-xl mt-6 font-medium  text-white">
                Contact us for Demo
              </div>

              <div className="flex items-center gap-5 my-20">
                <button
                  onClick={() => setContactForm(true)}
                  className="w-full bg-yellow-600 hover:bg-yellow-500 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-yellow-500/40 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>

            <div className="bg-slate-800/60 backdrop-blur-lg rounded-3xl shadow-xl border border-slate-700 p-10  hover:shadow-yellow-500/20 transition duration-300">
              <h3 className="text-2xl font-semibold mb-3">Professional</h3>
              <div className="text-4xl font-bold mt-6 text-yellow-400">
                <span className="text-xl text-slate-200">Document</span> 12 GB
              </div>

              <div className="flex items-center gap-5 my-20">
                <button
                  onClick={() => {
                    // navigate('/')
                  }}
                  className="w-full bg-white text-yellow-700 font-semibold py-3 rounded-xl shadow-md hover:bg-slate-100 transition"
                >
                  Start Trial
                </button>
                <button
                  onClick={() => {
                    setTrialForm(true);
                    setUsers(" for 12 GB");
                  }}
                  className="w-full bg-yellow-600 hover:bg-yellow-500 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-yellow-500/40 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default DMS;
